<template>
  <!--<div class="fullscreen">-->
  <Background>
    <!--<div class="library-icon-container" v-ripple="{ center: true }">
      <LockQuestionIcon
        @click="showSidePanel = !showSidePanel"
        class="library-icon"
        v-ripple
        size="3rem"
      />
    </div>-->
    <IconButton
      id="library-icon"
      class="library-icon"
      @click="showSidePanel = !showSidePanel"
      type="library"
      :flash="highlightLibraryIcon"
    />
    <transition name="fade-in">
      <LevelStart v-if="showLevelStartScreen" />
    </transition>
    <transition name="fade-in"><Unlock3 v-if="showUnlockDialog" /></transition>
    <transition name="fade-in">
      <IntroScreen v-if="showIntroScreen" />
    </transition>
    <transition name="slide-in">
      <!--<div v-if="showSidePanel" class="side-panel">
        <button @click="showSidePanel = !showSidePanel">close</button>
      </div>-->
      <SidePanel v-if="showSidePanel" @close="showSidePanel = !showSidePanel" />
    </transition>
    <transition name="dialog">
      <DialogConfirm v-if="showConfirmDialog" />
    </transition>
    <div
      id="main-code-container"
      ref="code-container"
      class="code-container"
      :key="reRender"
    >
      <div
        v-for="i in 9"
        :id="`button-${i}`"
        :ref="i"
        :key="i"
        class="code-button noSelect"
        @mousedown="mousedown(i, $event)"
        @touchstart="mousedown(i, $event)"
      >
        {{ button_vals[i - 1] }}
      </div>
    </div>
    <transition name="fade-in">
      <TutorialCodeScreen
        v-if="showTutorial"
        :positions="tutorialPositions"
        @close="showTutorial = false"
      />
    </transition>
  </Background>
  <!--</div>-->
</template>

<script>
/*
touchend event not triggered if DOM element removed:
https://bugs.chromium.org/p/chromium/issues/detail?id=464579
*/
import expand from '@/actions/expand.js'
import slingshot from '@/actions/slingshot.js'
import tripleclick from '@/actions/tripleclick.js'
import roundtheoutside from '@/actions/roundtheoutside2.js'
import spinner from '@/actions/spinner.js'
import sliderotate from '@/actions/sliderotate3.js'

import Unlock3 from '@/components/Unlock3.vue'
import IntroScreen from '@/components/IntroScreen.vue'
import Background from '@/components/Background.vue'
import SidePanel from '@/components/SidePanel.vue'
import IconButton from '@/components/IconButton.vue'
import LevelStart from '@/components/LevelStart.vue'
import DialogConfirm from '@/components/DialogConfirm.vue'
import TutorialCodeScreen from '@/components/TutorialCodeScreen.vue'

import gsap from 'gsap'
import { playBeep, playErrorBeep } from '@/lib/sound.js'

//import LockQuestionIcon from 'vue-material-design-icons/LockQuestion.vue'

export default {
  name: 'CodeScreenBase',
  components: {
    Unlock3,
    Background,
    IntroScreen,
    SidePanel,
    IconButton,
    LevelStart,
    DialogConfirm,
    TutorialCodeScreen,
  },
  data() {
    return {
      showSidePanel: false,
      showTutorial: false,
      tutorialPositions: {},
    }
  },
  computed: {
    codeScreen() {
      return this.$store.getters.codeScreen
    },
    codeScreenProps() {
      return this.$store.getters.codeScreenProps
    },
    button_vals() {
      return this.$store.getters.button_vals
    },
    reRender() {
      return this.$store.getters.reRender
    },
    blockClicks() {
      return this.$store.getters.blockClicks
    },
    showUnlockDialog() {
      return this.$store.getters.showUnlockDialog
    },
    showIntroScreen() {
      return this.$store.getters.showIntroScreen
    },
    showLevelStartScreen() {
      return this.$store.getters.showLevelStartScreen
    },
    showConfirmDialog() {
      return this.$store.getters.showConfirmDialog
    },
    thisScreenShowing() {
      return !this.showIntroScreen && !this.showLevelStartScreen
    },
    highlightLibraryIcon() {
      return (
        this.$store.getters.level == 0 &&
        this.$store.getters.unlockedActions.length >= 1 &&
        !this.$store.getters.libraryTutorialSeen &&
        this.$store.getters.userWantsTutorial
      )
    },
    /*showSecondTutorial() {
      const progress = Math.min(
        Math.max(0, Math.floor(this.$store.getters.unlockProgress)),
        100
      )

      if (this.$store.getters.tutorialStage == 3 && progress == 300) {
        return true
      } else {
        return false
      }
    },*/
  },
  mounted() {
    window.addEventListener('resize', this.calculatePositions)
    this.calculatePositions()
  },
  methods: {
    confirmTutorial() {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('show_confirmation_dialog', {
          message:
            'It looks like this is your first time playing. Would you like to see the tutorial?',
          buttons: [
            { message: 'Yes', callBack: resolve },
            { message: 'No', callBack: reject },
          ],
        })
      })
        .then(() => {
          this.$store.commit('SET_USER_WANTS_TUTORIAL', true)
          this.$store.dispatch('clear_confirmation_dialog')
          setTimeout(() => {
            this.showTutorial = true
          }, 500)
        })
        .catch(() => {
          this.$store.commit('SET_USER_WANTS_TUTORIAL', false)
          this.$store.dispatch('clear_confirmation_dialog')
        })
    },
    calculatePositions() {
      console.log('recalculate positions')
      if (!(this.$refs['code-container'] === undefined)) {
        this.tutorialPositions['code-container'] = this.$refs[
          'code-container'
        ].getBoundingClientRect()
      }

      let elem = document.getElementById('button-6')
      if (!(elem === null)) {
        this.tutorialPositions['button-6'] = elem.getBoundingClientRect()
      }

      elem = document.getElementById('progress-size-dummy')
      if (!(elem === null)) {
        this.tutorialPositions['progress'] = elem.getBoundingClientRect()
      }

      elem = document.getElementById('library-icon')
      if (!(elem === null)) {
        this.tutorialPositions['library-icon'] = elem.getBoundingClientRect()
      }

      this.tutorialPositions = Object.assign({}, this.tutorialPositions)
    },
    mousedown(ref, event) {
      event.preventDefault()

      if (this.blockClicks.includes(+ref)) {
        this.animateButton(ref, true)
      } else {
        this.animateButton(ref, false)

        if (ref == 1 || ref == 2 || ref == 3) {
          tripleclick(event)
        }
        if (ref == 6) {
          slingshot(event)
        }
        if (ref == 5) {
          expand()
        }
        if (ref == 4) {
          spinner(event)
        }
        if (ref == 8) {
          roundtheoutside(event)
        }
        if (ref == 7) {
          sliderotate(event)
        }
      }
    },
    animateButton(ref, locked) {
      if (locked) {
        playErrorBeep()
        gsap.from(`#button-${ref}`, {
          // #FF3633
          backgroundColor: 'rgba(100,21,20,1)',
          duration: 0.3,
        })
      } else {
        playBeep()
        gsap.from(`#button-${ref}`, {
          backgroundColor: 'rgba(205,244,221,0.3)',
          duration: 0.3,
        })
      }
    },
  },
  watch: {
    thisScreenShowing(new_val, old_val) {
      if (
        !this.$store.getters.mainTutorialSeen &&
        this.$store.getters.level == 0
      ) {
        if (new_val && !old_val) {
          setTimeout(() => {
            this.confirmTutorial()
          }, 500)
        }
      }
    },
  },
}
</script>

<style>
.fullscreen {
  /*position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;*/
  height: 100%;
  width: 100%;
  background-color: #003745;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.library-icon {
  position: absolute;
  right: 1rem;
  top: 1rem;
}

.code-container {
  color: #cdf4dd;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: clamp(0.25rem, 3vmin, 0.75rem);
  row-gap: clamp(0.25rem, 3vmin, 0.75rem);
  /*column-gap: 0.75rem;*/
  /*row-gap: 0.75rem;*/
}

.code-button {
  /*width: 3rem; 
  height: 3rem;*/
  width: clamp(2rem, 17.6vmin, 4.5rem);
  height: clamp(2rem, 17.6vmin, 4.5rem);
  border-radius: 50%;
  border: 0.5px solid #cdf4dd;
  display: flex;
  justify-content: center;
  align-items: center;
  /*font-size: 2rem;*/
  font-size: clamp(1rem, 8.8vmin, 2.5rem);
  font-family: 'Open Sans';
  font-weight: 100;
  cursor: pointer;
  user-select: none;
}

.noSelect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.code-button:focus {
  background: darkgreen;
}

.fade-in-enter {
  opacity: 0;
}

.fade-in-enter-active {
  transition: opacity 0.5s;
}

.fade-in-leave-to {
  opacity: 0;
}

.fade-in-leave-active {
  transition: opacity 0.5s;
}

.slide-in-enter {
  right: -100%;
}

.slide-in-enter-active {
  transition: right 0.3s;
}

.slide-in-leave-to {
  right: -100%;
}

.slide-in-leave-active {
  transition: right 0.3s;
}

.dialog-enter.dialog-fullscreen,
.dialog-leave-to.dialog-fullscreen {
  background-color: rgba(0, 0, 0, 0);
}

.dialog-enter .dialog-container,
.dialog-leave-to .dialog-container {
  opacity: 0;
  transform: scale(0.7);
}
</style>
